import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getInspectionList as getInspectionListApi,
	getInspectionListQuery as getInspectionListQueryApi,
	getInspection as getInspectionApi,
	addNewInspectionApi,
	updateInspectionApi,
	deleteInspectionApi,
} from '../../helpers/inspection/api_helper';

export const getInspectionList = createAsyncThunk(
	'inspection/getInspectionList',
	async params => {
		try {
			const response = await getInspectionListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las fiscalizaciones.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getInspectionListQuery = createAsyncThunk(
	'inspection/getInspectionListQuery',
	async params => {
		try {
			const response = await getInspectionListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getInspection = createAsyncThunk(
	'inspection/getInspection',
	async inspection_id => {
		try {
			const response = await getInspectionApi(inspection_id);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener la fiscalización.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewInspection = createAsyncThunk(
	'inspection/addNewInspection',
	async inspection => {
		try {
			const response = await addNewInspectionApi(inspection);
			toast.success('Fiscalización agregada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar fiscalización.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateInspection = createAsyncThunk(
	'inspection/updateInspection',
	async inspection => {
		try {
			const response = await updateInspectionApi(inspection);
			toast.success('Fiscalización actualizada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar fiscalización.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteInspection = createAsyncThunk(
	'inspection/deleteInspection',
	async inspection => {
		try {
			await deleteInspectionApi(inspection._id);
			toast.success('Fiscalización eliminada exitosamente.', {
				autoClose: 3000,
			});
			return inspection;
		} catch (error) {
			toast.error('Error al eliminar fiscalización.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
